import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchNextActivity } from "../APIServices/ActivityDetails";
import { performActionService } from "../APIServices/performAction";
import { activateLoading, deactivateLoading } from "./GlobalSlice";
export interface ActivitySliceState {
  activity: any;
  additionalInfo: any;
  action: any;
  subActivity: any;
}

const initialState: ActivitySliceState = {
  activity: null,
  additionalInfo: null,
  action: null,
  subActivity: null,
};

export const ActivitySlice = createSlice({
  name: "Activity",
  initialState,
  reducers: {
    initializedStateAction: (state) => {
      state.activity = null;
      state.additionalInfo = null;
      state.action = null;
      state.subActivity = null;
    },
    clearSubActivityStateAction: (state) => {
      state.subActivity = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(retriveActivity.fulfilled, (state, action) => {
      if (action?.payload) {
        state.activity = action?.payload?.activity;
        state.additionalInfo = action?.payload?.additionalInfo;
        state.action = action?.payload?.action;
      }
    });
    builder.addCase(performActionActivity.fulfilled, (state, action) => {
      if (action?.payload) {
        state.activity = action?.payload?.activity;
        state.additionalInfo = action?.payload?.additionalInfo;
        state.action = action?.payload?.action;
      }
    });
    builder.addCase(retriveSubActivity.fulfilled, (state, action) => {
      if (action?.payload) {
        state.subActivity = action?.payload?.activity;
        state.additionalInfo = action?.payload?.additionalInfo;
        state.action = action?.payload?.action;
      }
    });
  },
});
export const retriveActivity = createAsyncThunk(
  "Activity/retriveActivity",
  async (payload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response = await fetchNextActivity(payload?.data);
    if (response?.errors && response?.errors?.length > 0 && payload?.callback) {
      response?.errors?.forEach((err: any) => {
        payload?.callback(err?.message);
      });
      dispatch(deactivateLoading());
      return;
    }
    if (response?.data?.retrieveActivity?.action?.status && payload?.callback) {
      payload?.callback(response?.data?.retrieveActivity?.action?.message);
      dispatch(deactivateLoading());
    }
    dispatch(deactivateLoading());
    return response?.data?.retrieveActivity;
  }
);
export const performActionActivity = createAsyncThunk(
  "Activity/performActionActivity",
  async (payload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response = await performActionService(payload?.data);
    if (response?.errors && response?.errors?.length > 0 && payload?.callback) {
      response?.errors?.forEach((err: any) => {
        payload?.callback(err?.message, "error");
      });
      dispatch(deactivateLoading());
      return;
    }
    if (response?.data?.performAction?.action?.status && payload?.callback) {
      payload?.callback(
        response?.data?.performAction?.action?.message,
        "success"
      );
      dispatch(deactivateLoading());
    }
    dispatch(deactivateLoading());
    return response?.data?.performAction;
  }
);
export const retriveSubActivity = createAsyncThunk(
  "Activity/retriveSubActivity",
  async (payload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response = await fetchNextActivity(payload?.data);
    if (response?.errors && response?.errors?.length > 0 && payload?.callback) {
      response?.errors?.forEach((err: any) => {
        payload?.callback(err?.message);
      });
      dispatch(deactivateLoading());
      return;
    }
    if (response?.data?.retrieveActivity?.action?.status && payload?.callback) {
      payload?.callback(response?.data?.retrieveActivity?.action?.message);
      dispatch(deactivateLoading());
    }
    dispatch(deactivateLoading());
    return response?.data?.retrieveActivity;
  }
);

export const { initializedStateAction, clearSubActivityStateAction } =
  ActivitySlice.actions;
export default ActivitySlice.reducer;
